import { Record } from 'immutable';
import type BusinessPartnerConstants from '~/constants/business-partner-constants';
import CompanyTypeConstants from '~/constants/company-type-constants';
import InviteRequestStatusConstants from '~/constants/invite-request-status-constants';

const keys: EditInviteRequestFormFields = {
  inviteRequestId: '',
  status: InviteRequestStatusConstants.UNDEFINED,
  companyName: '',
  firstName: '',
  lastName: '',
  email: '',
  contactNumber: '',
  country: '',
  language: '',
  businessPartner: '',
  notes: '',
  timeZone: '',
  educational: false,
  companyType: CompanyTypeConstants.UNDEFINED,
};

export interface EditInviteRequestFormFields {
  inviteRequestId: string;
  status: InviteRequestStatusConstants;
  companyName: string;
  firstName: string;
  lastName: string;
  email: string;
  contactNumber: string;
  country: string;
  language: string;
  businessPartner: BusinessPartnerConstants | '';
  notes: string;
  timeZone: string;
  educational: boolean;
  companyType: CompanyTypeConstants;
}

export default class EditInviteRequestFormRecord extends Record<EditInviteRequestFormFields>(
  keys
) {}
